export const keys = {
  all: ['settings'] as const,
  profile: () => [...keys.all, 'profile'] as const,
  reminders: () => [...keys.all, 'reminders'] as const,
  dueReminders: () => [...keys.all, 'due-reminders'] as const,
};
